import {applyMiddleware} from 'redux';
import {composeWithDevTools} from 'redux-devtools-extension';
import {createLogger} from 'redux-logger';
import thunk from 'redux-thunk';
import {verboseLogging} from '../config/environment.js';
import {asyncManager} from './asyncManagerMiddleware';
import {orchestrateBehaviourModels} from './behaviourModelsMiddleware';
import {orchestrateBoundaryData} from './boundariesMiddleware';
import {orchestrateBurnPrescriptions} from './burnPrescriptionsMiddleware';
import {exportData} from './exportMiddleware';
import {orchestrateGraphData} from './graphsMiddleware';
import {handleInactivity} from './inactivityMiddleware';
import {incident} from './incidentMiddleware';
import {extractOverlayIntervals} from './indicatorOverlaysMiddleware';
import {orchestrateIndicators} from './indicatorsMiddleware';
import {interTab} from './interTabMiddleware';
import {location} from './locationMiddleware';
import {manualWeatherAugmenter, manualWeatherPersistence} from './manualWeatherMiddleware';
import {orchestrateOverlayData} from './overlayMiddleware';
import {orchestratePlay} from './playMiddleware';
import {orchestratePointDetails} from './pointDetailsMiddleware';

import {orchestrateTime} from './timeMiddleware';

const logger = verboseLogging ? createLogger() : _store => next => action => next(action);

const middleware = composeWithDevTools(applyMiddleware(
  logger,
  thunk,
  asyncManager,
  orchestrateTime,
  orchestrateOverlayData,
  orchestrateBoundaryData,
  orchestrateIndicators,
  orchestrateGraphData,
  orchestrateBehaviourModels,
  orchestrateBurnPrescriptions,
  orchestratePointDetails,
  orchestratePlay,
  location,
  extractOverlayIntervals,
  incident,
  handleInactivity,
  manualWeatherAugmenter,
  manualWeatherPersistence,
  exportData,
  interTab
));

export default middleware;



// WEBPACK FOOTER //
// ./src/middleware/index.js